var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 500",
    style: {
      enableBackground: "new 0 0 270 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83B3E2;}\n\t.st1{fill:#D0DE8E;}\n\t.st2{fill:#F9DB00;}\n\t.st3{fill:#1F54B0;}\n\t.st4{fill:#D03632;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st6{fill:#D1D1D1;}\n\t.st7{fill:#4C702B;}\n\t.st8{fill:#93B838;}\n\t.st9{fill:#B1CC40;}\n\t.st10{fill:#CAF741;}\n\t.st11{fill:#FEF7CE;}\n\t.st12{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wasser"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "185.7,500 90.7,331.3 93.6,329.6 189.2,500  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177,460.8c-3.5,1.1-1.9,5.8-1.7,6.5s1.6,5,5.7,3.5c3.7-1.4,2.3-5.4,1.5-6.7S180.1,459.8,177,460.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.8,430.9c2.6,9.6,2.7,14.7-1.2,15.8c-5,1.4-6.7-4.4-8.6-12.7c-1.8-7.3-2.3-12.8,1.3-13.9 C170.3,418.6,171.8,423.5,173.8,430.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,403.8c-0.1,1.2-1.1,2.2-2.4,2.1l-4.5-0.3c-1.2-0.1-2.2-1.1-2.1-2.4l0.8-12.9c0.1-1.2,1.1-2.2,2.4-2.1 l4.5,0.3c1.2,0.1,2.2,1.1,2.1,2.4L157.5,403.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.5,442.9c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8c0,0,0,0,0,0 C169.2,439.1,167.5,440.8,167.5,442.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.4,401.1c0,2.1,1.7,3.8,3.8,3.8c2.1,0,3.8-1.7,3.8-3.8c0-2.1-1.7-3.8-3.8-3.8c0,0,0,0,0,0 C151.1,397.3,149.4,399,149.4,401.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.9,392.4c-0.3,2.1,1.1,4,3.2,4.3c2.1,0.3,4-1.1,4.3-3.2s-1.1-4-3.2-4.3c0,0,0,0,0,0 C152.2,388.9,150.3,390.4,149.9,392.4C149.9,392.4,149.9,392.4,149.9,392.4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag_00000163755406278146829970000003948650909823167126_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158,472.4c-3.6-0.7-4.4,4.2-4.6,5c-0.1,0.8-1,5.2,3.3,5.8c3.9,0.6,4.6-3.6,4.5-5.2 C161.3,476.3,161.2,473,158,472.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.9,477.6c-1,1.8-0.3,4.1,1.5,5.1c1.8,1,4.1,0.3,5.1-1.5c1-1.8,0.3-4.1-1.5-5.1c0,0,0,0,0,0 C157.2,475,154.9,475.7,153.9,477.6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M246,219.1c-3.1-3.8-15.1-21.6-19-27.9c-11-18.9-15-27.7-16-51.9c0.6-12,1.7-27.3,5-40.3 c3-11.9,16.8-21.1,24.2-26.1c1-0.7,1.9-1.3,2.6-1.8l1.3,1.9c-0.7,0.5-1.6,1.1-2.7,1.8c-7.2,4.8-20.5,13.7-23.3,24.8 c-3.2,12.8-4.3,28-4.9,39.7c1,23.6,4.9,32.2,15.6,50.7c3.8,6.2,15.7,23.9,18.8,27.6L246,219.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "163.3,0 165.6,0.2 225.9,85.4 224.1,86.7  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M160.3,349.3c-23.6-2.5-29.3-12.2-31.9-25.7s1.7-48.6,4.2-75s15.1-117,18.2-129.6s5.1-17.3,3.5-25 s5-9.4,2-15.4s-8.7-0.9-14.4-17.8c-3.9-11.4-5.6-24.8,5.6-31.3c13.1-7.6,29.3-6.7,38,5c7.3,9.8,13.5,20.6,13.5,31.5 c0,10.2-9,59.7-9.3,69.8c-0.4,17,2.2,36.8,0,48.5s-5,17-4.1,21.1c1.7,7.6,13.3,10.6,12.2,23c-1.7,18.9-12.4,11.3-13.3,39 c-0.2,6.7,4.4,8.1,3.5,15.5c-1.4,11.5-0.1,22.8-0.3,30.4C187.5,329.2,181.6,351.6,160.3,349.3"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187.1,65.7c0,0,1.1,5.2-1.1,14.1s-3.7,20-6.5,36.8c-3.9,24,2.5,41.3-1.7,63.6c-3.3,17.6-7.4,34.8-8.3,43.3 s6.3,23.9,6.9,34c0.8,15-1,32-0.4,43.5c1.3,23.5-5,37.1-22.2,34.4c-21.1-3.3-15.2-22.9-9.8-71.1s9.7-92.9,10.4-99.3 c0.9-8.5,3-30.2,6.3-38.3c2.2-5.4,4.2-7.2,4.4-12c0.2-3.5,0.2-6-3.8-15.5c-3.7-8.6,6.2-20.1,8.4-26 C174.5,71.5,187.1,65.7,187.1,65.7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M164.8,58.2c-1.2-2-2-5.3-3.9-7.1s-4.5-2.7-6.3-4.6c-3-3.4-0.9-11.7,6.2-12.7c4.9-0.7,5.3-8.1,10.1-7.2 c5.1,1,2.6,7.1,4.6,10.9c1.4,2.7,2.2,3.4,3.3,5.5c2,4.1,2,5.4,3.4,9.6c2.1,6.1,5.8,11.5,5.1,18.8c-0.3,3.3-0.6,7.1-2.4,8.5 c-2.2,1.7-10.9,2.8-14.7,1.1c-1.5-0.6-2.3-2.2-2.1-3.8c0.2-2.6,4-5.3,0.9-12.9C168.2,62.3,166,60.2,164.8,58.2"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M176.9,62.1c6.9-4.4,2.4-14.7,0.5-18.2s-5.8-9.4-12.7-8.8s-10,4.7-9,8.5c0.8,3.1,5.4,4.8,7.3,6.8 c2.5,2.7,2.9,5.3,4.4,8C168.7,60.8,172.7,64.7,176.9,62.1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M174.7,221.5c-2.3,1.4-1.4,5.5-0.9,7.1s-0.7,2.6-0.3,5.1c0.6,4.5,4.2,2.9,6.1,0.6c1.6-1.8,2.1-4.3,1.2-6.6 c-0.9-1.8-0.2-3.9-2-5.7C177.3,220.8,175.9,220.8,174.7,221.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.4,55.3c1.9,0.2,1.5,2.8,2.2,4s3.1,0.5,3.8,2.1s-0.1,2.4-0.5,3.8s-0.6,5.2-3.6,5.2 c-1.7-0.1-3.2-1.1-3.8-2.7c-0.8-1.8-0.3-3.5-0.5-4.4s-1-1.8-0.8-3.6S151.5,55,153.4,55.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M184.1,51.7c1.6,0.2,4.2-1.4,4.5-5.1c0.3-4-2.5-7.1-5.4-6.5c-2.1,0.4-3.5,1.6-3.2,3s2.1,2.5,1.9,4.1 S181.3,51.3,184.1,51.7"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.8,458.1c-0.1,0,0.2,2.1,0,2.2c0.1-0.3,0.2-0.7,0.2-1c0-1.6-1-2.9-2.5-3.4c1.8-0.9,2.5-3,1.6-4.7 c-0.5-1-1.4-1.7-2.4-1.9c1.4-1.4,1.3-3.6-0.1-5c-0.6-0.6-1.5-1-2.3-1c-0.9-1.7-3.1-2.4-4.8-1.4c-0.3,0.2-0.7,0.4-0.9,0.7l-0.5-0.2 c0.9-1.7,0.3-3.9-1.5-4.8c-0.2-0.1-0.3-0.2-0.5-0.2c0.1-0.3,0.2-0.7,0.2-1c0-2-1.6-3.6-3.5-3.6c-1,0-2,0.4-2.6,1.2l-2.5,4.9 l-6.7-9.1l8-4.4c1.1,1.6,3.3,2.1,4.9,1c1-0.7,1.6-1.8,1.6-3c0-0.3-0.1-0.7-0.2-1c1.9-0.2,3.3-2,3.1-3.9c-0.1-0.7-0.4-1.4-0.9-2 c0.2-0.4,0.3-0.9,0.3-1.4c0-2-1.6-3.6-3.6-3.6c-0.4,0-0.7,0.1-1.1,0.2c0.2-0.4,0.3-0.9,0.3-1.3c0-2-1.6-3.6-3.5-3.6 c-1,0-1.9,0.4-2.6,1.1c-0.5-0.6-1.2-1-1.9-1.2c1.5-1.3,1.6-3.5,0.3-5c-0.6-0.7-1.4-1.1-2.3-1.2c1.4-1.3,1.5-3.6,0.1-5 c-0.2-0.2-0.4-0.4-0.6-0.5c1.9-0.3,3.3-2.1,3-4c-0.1-1-0.7-1.9-1.5-2.5c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0.6,0.4,1.3,0.6,2,0.6 c0.1,0,0.2,0,0.3,0c-0.1,0.3-0.1,0.6-0.1,0.9c0,2,1.6,3.6,3.5,3.6c2,0,3.6-1.6,3.6-3.5c0-1.1-0.5-2.1-1.3-2.8 c1.4-1.3,1.5-3.6,0.2-5c-0.7-0.7-1.6-1.2-2.6-1.2c-0.4,0-0.7,0.1-1.1,0.2c-0.1-1.1-0.8-2.1-1.7-2.6c0.2,0,0.4,0.1,0.5,0.1 c2,0,3.6-1.6,3.6-3.6c0-0.9-0.3-1.8-1-2.4c0.9-0.7,1.4-1.7,1.4-2.8c0-2-1.6-3.6-3.6-3.6c-0.3,0-0.6,0-0.8,0.1c0-0.2,0-0.3,0.1-0.5 c0-1-0.4-1.9-1.1-2.5c0.4-0.6,0.6-1.2,0.6-1.9c0-2-1.6-3.6-3.6-3.6c-0.4,0-0.8,0.1-1.1,0.2c-0.2-2-2-3.4-3.9-3.2 c-2,0.2-3.4,2-3.2,3.9c0.1,0.9,0.6,1.8,1.3,2.4c-0.1,0.4-0.2,0.8-0.2,1.1c0,2,1.6,3.6,3.6,3.6h0.3c-0.1,0.3-0.1,0.6-0.1,0.9 c0,1.1,0.5,2.1,1.3,2.8c0,0.2-0.1,0.4-0.1,0.6c0,0.8,0.3,1.6,0.8,2.2c-0.9,1.7-0.3,3.9,1.4,4.8c0.5,0.3,1.1,0.4,1.7,0.4l0,0 c0.2,0.2,0.5,0.4,0.8,0.6c-0.2,0-0.4,0-0.6,0c-1.1,0-2.2,0.5-2.9,1.5c-0.4-0.2-0.9-0.3-1.3-0.2c-0.4,0-0.9,0.1-1.2,0.2 c-0.3-0.9-0.9-1.6-1.7-2c1.7-1,2.3-3.1,1.3-4.8c-0.6-1.1-1.8-1.8-3.1-1.8c-0.6,0-1.1,0.1-1.6,0.4c-0.6-0.6-1.5-1-2.4-1 c-2,0-3.6,1.6-3.6,3.6c0,0.2,0,0.4,0,0.6l-3,0.5l-0.4-3c1.9-0.3,3.3-2.1,3-4c-0.2-1.2-1-2.3-2.2-2.8c0.6-0.7,1-1.5,1-2.5 c0-0.6-0.2-1.2-0.5-1.7c0.3,0.1,0.6,0.1,0.9,0.1c2,0,3.6-1.6,3.6-3.5c0-1.3-0.7-2.5-1.9-3.2c0.3-0.6,0.3-1.3,0.2-2l0.3,0 c0,2,1.7,3.5,3.6,3.5s3.5-1.7,3.5-3.6c0-0.9-0.4-1.9-1.1-2.5c0.2-0.4,0.3-0.7,0.3-1.1c0.2-2-1.3-3.7-3.2-3.8c0,0,0,0,0,0h-0.3 c0.1-0.3,0.2-0.6,0.2-0.9c0.1-2-1.5-3.6-3.4-3.7c-1.9-0.1-3.5,1.3-3.7,3.1c0,0.4,0,0.8,0.1,1.1c-0.5-0.3-1.1-0.4-1.7-0.5 c-0.2,0-0.4,0-0.7,0.1c-0.4-0.9-1.1-1.6-2-2c0.9-1.7,0.3-3.9-1.5-4.8c-0.1,0-0.1-0.1-0.2-0.1c1.1-1.4,0.9-3.5-0.4-4.7 c1.6-1.1,2.1-3.3,1-4.9c-1.1-1.6-3.3-2.1-4.9-1c-1,0.6-1.6,1.7-1.6,2.9c-1.7-0.9-3.9-0.2-4.7,1.5c-0.1,0.2-0.2,0.4-0.3,0.6 c-0.4-0.2-0.8-0.2-1.2-0.2c-2,0-3.6,1.6-3.6,3.5c0,2,1.6,3.6,3.5,3.6c0.7,0,1.4-0.2,2-0.6l1.7,2.7l-9.2,2.2l6.1,8l-0.9,10.7 l9.3,6.7L90,378.9l-9.8,3.7l8.2,8.3l-1.7,10.9l-10.6,2.4l7.6,8l6.7,8.8l10,9.1l-8.5,6.7l-2,10.7l10.9,5.5l3,9.1l8,7.8l10.7-3.1 l10.9,0.7l3.6-0.2c0,0.1,0,0.2,0,0.2c0.1,2,1.8,3.5,3.8,3.4c1.8-0.1,3.3-1.6,3.4-3.4c0-0.1-3.4,0.9-3.4,0.8c-5.2,0.2-0.4-3,0-3 c2,0.1,2.3,0.2,2.4-1.7c0.1-2,4.5-3.2,2.6-3.3c-0.1,0-0.3,0-0.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M199.5,371.8c-0.1-0.9-0.6-1.8-1.4-2.4c1.8-0.8,2.7-2.8,1.9-4.6c-0.2-0.4-0.4-0.7-0.7-1 c1.4-1.3,1.5-3.6,0.2-5c-0.6-0.7-1.5-1.1-2.4-1.1c-0.3-1.7-1.8-3-3.5-3c-0.2,0-0.4,0-0.6,0.1c1.1-1.6,0.8-3.8-0.8-5 c-1.6-1.1-3.8-0.8-5,0.8c-0.4,0.5-0.6,1.1-0.6,1.7c-1.8,0.7-2.7,2.8-2,4.6s2.8,2.7,4.6,2c0.3-0.1,0.7-0.3,0.9-0.5 c0.1,1.8,1.5,3.2,3.3,3.3c0.1,0.7,0.4,1.3,0.9,1.8c-1.4,1.3-1.5,3.6-0.2,5c0.1,0.2,0.3,0.3,0.5,0.4c-1.8,0.8-2.7,2.8-1.9,4.6 c0.4,1,1.3,1.8,2.4,2.1c0.2,2,2,3.3,4,3.1c2-0.2,3.3-2,3.1-4C201.9,373.4,200.9,372.2,199.5,371.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M205.1,348.8c0,1.7-1.4,3.2-3.1,3.2s-3.2-1.4-3.2-3.1c0-1.7,1.4-3.2,3.1-3.2c0,0,0,0,0,0 C203.7,345.6,205.1,347,205.1,348.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.4,98.3c0,1.7-1.4,3.2-3.1,3.2c-1.7,0-3.2-1.4-3.2-3.1c0-1.7,1.4-3.2,3.1-3.2c0,0,0,0,0,0 C142,95.1,143.4,96.5,143.4,98.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M141.2,87.2c0.9-1.5,0.3-3.4-1.2-4.3c-1.5-0.9-3.4-0.3-4.3,1.2c-0.9,1.5-0.4,3.4,1.1,4.3 c-0.3,0.5-0.4,1-0.4,1.6c0,1.7,1.4,3.2,3.1,3.2c1.7,0,3.2-1.4,3.2-3.1C142.7,88.8,142.1,87.8,141.2,87.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139.5,76.2c0.4-0.5,0.6-1.2,0.6-1.8c0-1.7-1.4-3.2-3.1-3.2c-1.7,0-3.2,1.4-3.2,3.2c0,0.9,0.5,1.8,1.2,2.4 c-1,1.4-0.7,3.4,0.7,4.4c1.4,1,3.4,0.7,4.4-0.7C141.1,79.2,140.8,77.3,139.5,76.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M137.9,65c0.3-0.5,0.5-1.1,0.5-1.8c0-1.7-1.4-3.1-3.2-3.1c-1.7,0-3.1,1.4-3.1,3.2c0,1.1,0.5,2.1,1.4,2.6 c-0.9,1.5-0.5,3.4,0.9,4.3c0.5,0.3,1.1,0.5,1.7,0.5c1.7,0,3.2-1.4,3.2-3.2C139.4,66.5,138.8,65.6,137.9,65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.2,385.1c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C111.7,379.7,114.2,382.1,114.2,385.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.6,375.6c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C103.2,370.2,105.6,372.7,105.6,375.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.3,366.3c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C107,361,109.4,363.4,109.3,366.3C109.4,366.4,109.4,366.4,109.3,366.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M95.1,379c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0C92.7,373.6,95.1,376,95.1,379"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.3,367.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0C94.9,362.5,97.3,364.9,97.3,367.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.2,361.4c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0C85.8,356,88.2,358.4,88.2,361.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.4,356.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.3-5.4C96,351.2,98.4,353.6,98.4,356.6 C98.4,356.6,98.4,356.6,98.4,356.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M88.6,350.1c0.1,3-2.2,5.4-5.2,5.6s-5.4-2.2-5.6-5.2c-0.1-2.9,2.2-5.4,5.1-5.6 C86,344.8,88.5,347.1,88.6,350.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M80.6,342.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C78.2,337.1,80.6,339.5,80.6,342.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M92,327c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0C89.6,321.6,92,324,92,327"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M96.9,316.3c0,3-2.4,5.4-5.3,5.4c-3,0-5.4-2.4-5.4-5.3c0-3,2.4-5.4,5.3-5.4c0,0,0,0,0,0 C94.5,311,96.9,313.4,96.9,316.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.3,319.2c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C87,313.9,89.4,316.3,89.3,319.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.6,309.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C87.2,304,89.6,306.4,89.6,309.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.4,339.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C89,334.5,91.4,336.9,91.4,339.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.4,331c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C106,325.6,108.4,328,108.4,331"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M195.4,450.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C193,445.6,195.4,448,195.4,450.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M193,431.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C190.6,426.5,193,428.9,193,431.9L193,431.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M200.8,410.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C198.4,405.4,200.8,407.8,200.8,410.8L200.8,410.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201.3,380.1c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C198.9,374.7,201.3,377.1,201.3,380.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M200.1,372.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C197.7,367.5,200.1,369.9,200.1,372.8C200.1,372.8,200.1,372.8,200.1,372.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M204.3,362.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C201.9,357.5,204.3,359.9,204.3,362.8L204.3,362.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.3,346.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C195.9,341,198.3,343.4,198.3,346.3C198.3,346.3,198.3,346.3,198.3,346.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M208,312.3c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C205.6,307,208,309.4,208,312.3C208,312.3,208,312.3,208,312.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.2,445.6c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C106.7,440.2,109.2,442.6,109.2,445.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M101.7,437.2c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C99.3,431.9,101.7,434.3,101.7,437.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M120.1,442.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C117.7,437.4,120.1,439.8,120.1,442.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.3,435.2c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C109.9,429.8,112.3,432.2,112.3,435.2C112.3,435.2,112.3,435.2,112.3,435.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M126.2,422.4c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C123.8,417.1,126.2,419.5,126.2,422.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.4,424.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C113,419.5,115.4,421.9,115.4,424.8C115.4,424.8,115.4,424.8,115.4,424.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.9,427.2c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C102.5,421.9,104.9,424.3,104.9,427.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M96.9,420c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C94.5,414.6,96.9,417,96.9,420"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.5,416.9c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C105.1,411.5,107.5,413.9,107.5,416.9C107.5,416.9,107.5,416.9,107.5,416.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118,414.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0C115.6,409.3,118,411.7,118,414.7 C118,414.6,118,414.7,118,414.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.3,406.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C107.9,401,110.3,403.4,110.3,406.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M99.9,409.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C97.5,403.9,99.9,406.3,99.9,409.3C99.9,409.3,99.9,409.3,99.9,409.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.2,411.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C86.7,406.5,89.1,408.9,89.2,411.9C89.2,411.9,89.2,411.9,89.2,411.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M81.4,404.3c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4C79,398.9,81.4,401.3,81.4,404.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.6,401.3c0,3-2.4,5.4-5.3,5.4s-5.4-2.4-5.4-5.3c0-3,2.4-5.4,5.3-5.4c0,0,0,0,0,0 C89.2,396,91.6,398.4,91.6,401.3C91.6,401.4,91.6,401.4,91.6,401.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M101.9,397.6c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C99.5,392.3,101.9,394.7,101.9,397.6C101.9,397.6,101.9,397.6,101.9,397.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.7,395.6c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C110.3,390.2,112.7,392.6,112.7,395.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M103.6,386.3c0,3-2.4,5.4-5.3,5.4c-3,0-5.4-2.4-5.4-5.3c0-3,2.4-5.4,5.3-5.4c0,0,0,0,0,0 C101.2,381,103.6,383.4,103.6,386.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M93,390c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0C90.6,384.7,93,387.1,93,390"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84.5,383c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C82.1,377.6,84.5,380,84.5,383"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121.9,471.5c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C119.5,466.1,121.9,468.5,121.9,471.5C121.9,471.4,121.9,471.5,121.9,471.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.5,463.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C112.1,458.1,114.5,460.5,114.5,463.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M132.1,468.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C129.7,463.5,132.1,465.9,132.1,468.9C132.1,468.9,132.1,468.9,132.1,468.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M135.6,458.7c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C133.2,453.3,135.6,455.7,135.6,458.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.1,460.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C122.7,455.4,125.1,457.7,125.1,460.7C125.1,460.7,125.1,460.7,125.1,460.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M106.6,455.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C104.2,450.5,106.6,452.9,106.6,455.9C106.6,455.9,106.6,455.9,106.6,455.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M117.5,453.3c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C115.1,448,117.5,450.3,117.5,453.3C117.5,453.3,117.5,453.3,117.5,453.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.6,447.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0C96.2,442.4,98.6,444.8,98.6,447.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.8,450.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C125.4,445.4,127.8,447.8,127.8,450.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.2,448c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C135.8,442.6,138.2,445,138.2,448"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.4,440.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C128,435,130.4,437.4,130.4,440.4C130.4,440.4,130.4,440.4,130.4,440.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.7,432.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C120.3,427.2,122.7,429.6,122.7,432.6C122.7,432.6,122.7,432.6,122.7,432.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.3,466.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C102,460.9,104.4,463.3,104.3,466.3C104.4,466.3,104.4,466.3,104.3,466.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M148.5,465.3c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3c0,0,0,0,0,0 C145.8,459,148.6,461.8,148.5,465.3C148.6,465.3,148.6,465.3,148.5,465.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M141.5,416.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C139.1,411.3,141.5,413.7,141.5,416.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.6,401.4c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C126.2,396,128.6,398.4,128.6,401.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121,403.6c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0C118.6,398.2,121,400.6,121,403.6 C121,403.6,121,403.6,121,403.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M134.9,409.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C132.5,404.4,134.9,406.8,134.9,409.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.4,412.2c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C125,406.9,127.4,409.3,127.4,412.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.5,392.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C122.1,387.4,124.5,389.8,124.5,392.8C124.5,392.8,124.5,392.8,124.5,392.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M146.1,404.1c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C143.7,398.7,146.1,401.1,146.1,404.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139,389.3c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C136.6,383.9,139,386.3,139,389.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.2,396c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C140.8,390.6,143.2,393,143.2,396"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.4,439.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4C89,434.3,91.4,436.7,91.4,439.6 C91.4,439.6,91.4,439.6,91.4,439.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201.2,297.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C198.8,292.2,201.2,294.6,201.2,297.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M194.7,201.1c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C192.3,195.8,194.7,198.2,194.7,201.1C194.7,201.1,194.7,201.1,194.7,201.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M230.9,196.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C228.5,191.1,230.9,193.5,230.9,196.5C230.9,196.5,230.9,196.5,230.9,196.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M223.3,189.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C220.9,183.9,223.3,186.3,223.3,189.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M219.6,179.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C217.2,174.1,219.6,176.5,219.6,179.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236.6,230.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C234.2,225,236.6,227.4,236.6,230.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M249.4,220.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C247,215.6,249.4,218,249.4,220.9C249.4,220.9,249.4,220.9,249.4,220.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M247.2,231.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C244.8,226.3,247.2,228.7,247.2,231.7C247.2,231.6,247.2,231.7,247.2,231.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M238.5,239.2c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C236.1,233.9,238.5,236.3,238.5,239.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M224.5,236.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C222.1,231.5,224.5,233.9,224.5,236.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M207.3,244.1c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C204.9,238.7,207.3,241.1,207.3,244.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.6,266.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C189.2,261.1,191.6,263.5,191.6,266.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M196.2,276.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C193.8,271.1,196.2,273.5,196.2,276.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M203.8,280.7c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C201.4,275.3,203.8,277.7,203.8,280.7C203.8,280.7,203.8,280.7,203.8,280.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M204.2,304.4c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C201.8,299,204.2,301.4,204.2,304.4C204.2,304.4,204.2,304.4,204.2,304.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.7,223.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C110.3,218.5,112.7,220.9,112.7,223.9C112.7,223.9,112.7,223.9,112.7,223.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M110.8,241.9c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C108.4,236.5,110.8,238.9,110.8,241.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M240.6,89.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C238.2,84.2,240.6,86.6,240.6,89.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.5,97.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C230.1,92,232.5,94.4,232.5,97.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M210.5,129.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C208.1,124.5,210.5,126.9,210.5,129.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211.4,122.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.3,5.3-5.4 C209,117.5,211.4,119.9,211.4,122.9C211.4,122.9,211.4,122.9,211.4,122.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.8,144.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C212.4,139.4,214.8,141.8,214.8,144.8C214.8,144.8,214.8,144.8,214.8,144.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M212.9,158.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C210.5,153.4,212.9,155.8,212.9,158.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M201,120.1c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C198.6,114.8,201,117.2,201,120.1C201,120.1,201,120.1,201,120.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.6,107.2c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C211.2,101.8,213.6,104.2,213.6,107.2C213.6,107.2,213.6,107.2,213.6,107.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M216.1,96.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C213.6,91.4,216,93.8,216.1,96.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M221.8,88.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C219.4,82.9,221.8,85.3,221.8,88.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M228.2,74.2c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C225.8,68.9,228.2,71.3,228.2,74.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M235.6,76.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C233.2,71.5,235.6,73.9,235.6,76.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M220.8,63c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C218.4,57.6,220.8,60,220.8,63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213.2,53.3c0,3-2.4,5.4-5.3,5.4s-5.4-2.4-5.4-5.3c0-3,2.4-5.4,5.3-5.4c0,0,0,0,0,0 C210.8,48,213.2,50.4,213.2,53.3C213.2,53.4,213.2,53.4,213.2,53.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M202.7,35.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C200.3,30.2,202.7,32.6,202.7,35.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.3,169.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C212.9,164.5,215.3,166.9,215.3,169.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M121.4,46.3c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.3-5.4C119,40.9,121.4,43.3,121.4,46.3 C121.4,46.3,121.4,46.3,121.4,46.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.6,41.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C114.2,36.1,116.6,38.5,116.6,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M167.3,113.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C164.9,108.2,167.3,110.6,167.3,113.6C167.3,113.6,167.3,113.6,167.3,113.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.4,149.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C107,144.1,109.4,146.5,109.4,149.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M119.4,141.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C117,136.2,119.4,138.6,119.4,141.6C119.4,141.5,119.4,141.6,119.4,141.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M113.4,136.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C111,131.2,113.4,133.6,113.4,136.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M124.2,128.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C121.8,123.2,124.2,125.6,124.2,128.6C124.2,128.6,124.2,128.6,124.2,128.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M136.2,130.1c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C133.8,124.7,136.2,127.1,136.2,130.1C136.2,130.1,136.2,130.1,136.2,130.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.4,135.1c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C126,129.7,128.4,132.1,128.4,135.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198,139.9c0,4.5-3.5,8.1-8,8.1c-4.5,0-8.1-3.5-8.1-8c0-4.5,3.5-8.1,8-8.1c0,0,0,0,0.1,0 C194.4,131.9,198,135.5,198,139.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M112.5,189.2c0,4.5-3.6,8.1-8,8.1c-4.5,0-8.1-3.6-8.1-8.1c0-4.5,3.6-8.1,8-8.1c0,0,0,0,0,0 C108.8,181.2,112.5,184.8,112.5,189.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.8,275.4c0,4.5-3.6,8.1-8,8.1c-4.5,0-8.1-3.6-8.1-8s3.6-8.1,8-8.1c0,0,0,0,0,0 C88.2,267.3,91.8,270.9,91.8,275.4C91.8,275.4,91.8,275.4,91.8,275.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.5,271.1c0,4.5-3.6,8.1-8,8.1s-8.1-3.6-8.1-8s3.6-8.1,8-8.1l0,0C103.9,263.1,107.5,266.7,107.5,271.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M123.1,266.6c0,4.5-3.6,8.1-8,8.1c-4.5,0-8.1-3.6-8.1-8s3.6-8.1,8-8.1c0,0,0,0,0,0 C119.5,258.5,123.1,262.1,123.1,266.6C123.1,266.6,123.1,266.6,123.1,266.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.6,262.3c0,4.5-3.6,8.1-8,8.1c-4.5,0-8.1-3.6-8.1-8s3.6-8.1,8-8.1c0,0,0,0,0,0 C135,254.2,138.6,257.8,138.6,262.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.4,119.7c0,4.5-3.5,8.1-8,8.1c-4.5,0-8.1-3.5-8.1-8c0-4.5,3.5-8.1,8-8.1c0,0,0,0,0.1,0 C150.8,111.7,154.4,115.2,154.4,119.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M133.4,123.2c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C131,117.9,133.4,120.3,133.4,123.2C133.4,123.2,133.4,123.2,133.4,123.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M108.6,52.8c0,3-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4S108.6,49.8,108.6,52.8 C108.6,52.8,108.6,52.8,108.6,52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M99,50.7c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C96.6,45.3,99,47.7,99,50.7C99,50.7,99,50.7,99,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104,55.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C101.6,50.6,104,53,104,55.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.5,45.5c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C103.1,40.2,105.5,42.6,105.5,45.5C105.5,45.5,105.5,45.5,105.5,45.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M145.6,26.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C143.2,21.5,145.6,23.9,145.6,26.9C145.6,26.9,145.6,26.9,145.6,26.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M155.2,21.1c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C152.8,15.8,155.2,18.2,155.2,21.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.9,13.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c0,0,0,0,0,0 C189.5,8.6,191.9,11,191.9,13.9C191.9,13.9,191.9,13.9,191.9,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M192.5,20.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C190.1,15.2,192.5,17.6,192.5,20.6C192.5,20.6,192.5,20.6,192.5,20.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M182.9,11.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C180.4,6.5,182.8,8.9,182.9,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M184.9,18.9c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4l0,0 C182.5,13.5,184.9,15.9,184.9,18.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik3);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_3.1578c0c62685dab57e7cfbbc18668f9f.svg";
export { ForwardRef as ReactComponent };